





































import Vue from "vue"
import MaterialIcon, {
  FILLED,
} from "~/components/guideline/icon/MaterialIcon.vue"

interface OptionItem {
  name: string
  title: string
  description: string
  icon: string
  iconType: string
}

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    defaultValue: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: "",
    }
  },
  computed: {
    options(): OptionItem[] {
      return [
        {
          name: "open_to_public",
          title: "一般公開",
          description: "すべてのユーザーとインターネット上に公開",
          icon: "public",
          iconType: FILLED,
        },
        {
          name: "open_to_users",
          title: "クラウドリンクス内に公開",
          description:
            "クラウドリンクス利用企業とクラウドワークススタッフにのみ公開",
          icon: "groups",
          iconType: FILLED,
        },
        {
          name: "close",
          title: "クラウドリンクス内に限定公開",
          description:
            "スカウトを送ることができるクラウドリンクス利用企業とクラウドワークススタッフにのみ公開",
          icon: "business",
          iconType: FILLED,
        },
      ]
    },
  },
  watch: {
    defaultValue: {
      handler() {
        this.value = this.defaultValue
      },
      immediate: true,
    },
  },
  methods: {
    updateValue() {
      this.$emit("change", this.value)
    },
  },
})
